import React from 'react';
import * as App from 'modules/app/App';
import AdminResult from './AdminResult';
import CertificationResult from './CertificationResult';
import SponsorResult from './SponsorResult';

class Result extends React.Component {

	render() {
		let userTypeCode = App.context().userTypeCode;
		let result;

		if (userTypeCode === 'CER')
			result = <CertificationResult result={this.props.result} />;
		else if (userTypeCode === 'ADM')
			result = <AdminResult result={this.props.result} />;
		else if (userTypeCode === 'SPN')
			result = <SponsorResult result={this.props.result} />;

		return (
			<React.Fragment>
				{result}
			</React.Fragment >
		)
	}
}

export default Result;



// WEBPACK FOOTER //
// ./src/areas/main/search/Result.js